import React, { createContext, useEffect, useReducer, useState } from 'react';
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";

const initialValue = {
    attribute: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                attribute_model: action.payload,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const SizeContext = createContext({
    attribute_model: initialValue,
    getSizes: () => {},
    getSizeById: () => {},
    addSize: () => {},
    editSize: () => {},
    deleteSize: () => {},
})

export const SizesProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)


    const  { setError } = useError();

    const getSizes = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/get_sizes', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const getSizeById = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/get_size/'+id, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const addSize = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/products/add_size', data, options);

            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    const editSize = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/products/edit_size', data, options);

            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    const deleteSize = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.delete('/api/products/delete_size/'+id, options);

            await getSizes();

            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Error", message: e.response?.data?.message??"Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    useEffect(() => {
        getSizes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if(state.status === 401){
        return <SessionOut />
    }

    if(state.attribute_model === undefined) {
        return <MatxLoading />
    }

    return (
        <SizeContext.Provider
            value={{
                attribute_model: state.attribute_model,
                getSizes,
                getSizeById,
                addSize,
                editSize,
                deleteSize,
            }}
        >
            {children}
        </SizeContext.Provider>
    )
}

export default SizeContext
